//src/pages/ForgotPassword.jsx

import { useState } from 'react';
import axiosInstance from '../axiosInstance';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Avatar, Button, TextField, Grid, Box, Typography, Paper, CssBaseline } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';

// Usamos el mismo fondo que el Login para consistencia
import backgroundImage from '../assets/login.jpeg'; 

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const emailTrim = email.trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailTrim || !emailRegex.test(emailTrim)) {
      toast.error('Por favor ingresa un correo válido.');
      return;
    }

    setLoading(true);

    try {
      await axiosInstance.post('/auth/custom-password-reset/', { email: emailTrim });

      // Mensaje neutral por privacidad (no revelar si existe o no la cuenta)
      toast.success('Si el correo está registrado, te enviaremos un enlace para restablecer tu contraseña.');
      navigate('/login', { replace: true });
    } catch (err) {
      console.error('Error al solicitar reseteo de contraseña:', err);

      // Opción privacidad: mismo mensaje también ante error para no revelar la existencia de la cuenta
      toast.success('Si el correo está registrado, te enviaremos un enlace para restablecer tu contraseña.');
      navigate('/login', { replace: true });

      // Si prefieres mostrar el error real (menos privado), reemplaza las 2 líneas de arriba por:
      // if (err.response) {
      //   toast.error(err.response.data?.error || 'Ocurrió un error. Por favor, intenta de nuevo.');
      // } else {
      //   toast.error('Ocurrió un error. Por favor, intenta de nuevo.');
      // }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CssBaseline />
      <Grid
        item
        xs={11}
        sm={8}
        md={5}
        lg={4}
        component={Paper}
        elevation={6}
        sx={{ p: 4, borderRadius: 4, backgroundColor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(4px)' }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockResetIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Restablecer Contraseña
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
            Ingresa tu correo electrónico y te enviaremos un enlace para que puedas recuperar tu cuenta.
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Correo Electrónico"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              disabled={loading}
            />
            <Button 
              type="submit" 
              fullWidth 
              variant="contained" 
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Enviar Enlace'}
            </Button>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button component={RouterLink} to="/login" size="small" disabled={loading}>
                Volver a Iniciar Sesión
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
